export class SafeHtml {
    constructor(value) {
        this.value = value;
    }
    toString() {
        return this.value;
    }
}
function escapeHtml(value) {
    return value
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
}
function render(value) {
    if (value instanceof SafeHtml) {
        return value.value;
    }
    if (value === null || value === undefined || value === false) {
        return "";
    }
    if (Array.isArray(value)) {
        return value.map(render).join("");
    }
    return escapeHtml(String(value));
}
// Escapes interpolated values unless they are trusted fragments (nested htmlSafe,
// safe(), or arrays of those). Arrays are flattened, so no .join() at call sites.
export const htmlSafe = (strings, ...keys) => {
    let out = strings[0];
    for (let i = 0; i < keys.length; i++) {
        out += render(keys[i]) + strings[i + 1];
    }
    return new SafeHtml(out);
};
// Marks a string as trusted HTML. Only for strings known to be free of untrusted input.
export function safe(value) {
    return new SafeHtml(value);
}
//# sourceMappingURL=html.js.map